import React, { ReactNode } from 'react';

import { useDevice } from '@contexts/device';
import { DownArrowIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';

import {
  ResponsiveSearchDrawerItemContent,
  ResponsiveSearchDrawerItemText,
  ResponsiveSearchDrawerItemTitle,
  ResponsiveSearchDrawerItemSubtitle,
} from '../ResponsiveListingSearchStyle';

type CustomIconProps = React.ComponentType<
  React.PropsWithChildren<
    React.PropsWithChildren<
      React.PropsWithChildren<
        React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
      >
    >
  >
>;
export interface ResponsiveDrawerInterface {
  icon:
    | React.FunctionComponent<
        React.PropsWithChildren<
          React.PropsWithChildren<
            React.PropsWithChildren<
              React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
            >
          >
        >
      >
    | React.ComponentClass<React.SVGProps<SVGSVGElement>, any>
    | undefined;

  title: string;
  subTitle: string | ReactNode;
  arrowIcon?: boolean;
  isFilled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;

  className?: string;
  placeholder?: string;
  arrowIconType?: CustomIconProps;
}

const ResponsiveSearchDrawerItem = ({
  icon,
  title,
  subTitle,
  arrowIcon,
  isFilled,
  onClick = () => false,
  className,
  placeholder,
  arrowIconType = DownArrowIcon,
}: ResponsiveDrawerInterface) => {
  const { isDesktop } = useDevice();
  return (
    <ResponsiveSearchDrawerItemContent
      role='button'
      tabIndex={-1}
      onClick={onClick}
      className={className}
    >
      <CustomIcon icon={icon} fontSize={28} paletteColor='coral' />
      <div style={{ width: isDesktop ? 13 : 20 }} />
      <ResponsiveSearchDrawerItemText>
        <ResponsiveSearchDrawerItemTitle
          isFilled={
            isFilled || (typeof subTitle === 'string' && subTitle.length > 0)
          }
        >
          {title}
        </ResponsiveSearchDrawerItemTitle>
        <br />
        <ResponsiveSearchDrawerItemSubtitle isEmpty={!subTitle}>
          {subTitle || placeholder}
        </ResponsiveSearchDrawerItemSubtitle>
      </ResponsiveSearchDrawerItemText>

      {arrowIcon && <CustomIcon fontSize={16} icon={arrowIconType} />}
    </ResponsiveSearchDrawerItemContent>
  );
};

export default ResponsiveSearchDrawerItem;
